import 'mapbox-gl/dist/mapbox-gl.css'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VTooltip from 'v-tooltip'
import VueCharts from 'vue-chartjs'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faMapMarked, faHome,
  faArrowsAltH, faUserAlt,
  faUsers, faDollarSign,
  faSlidersH, faTimes,
  faShareSquare, faFileDownload,
  faWifi, faNetworkWired, faLaptopHouse, faInfo, faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 1300,
    lg: Infinity,
  },
  defaultBreakpoint: 'lg',
})

Vue.use(VTooltip)
Vue.use(VueCharts)

Vue.use(VueRouter)

library.add(faMapMarked)
library.add(faHome)
library.add(faArrowsAltH)
library.add(faUserAlt)
library.add(faUsers)
library.add(faDollarSign)
library.add(faSlidersH)
library.add(faTimes)
library.add(faShareSquare)
library.add(faFileDownload)
library.add(faWifi)
library.add(faNetworkWired)
library.add(faLaptopHouse)
library.add(faInfo)
library.add(faInfoCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.config.performance = (process.env.NODE_ENV !== "production");

VTooltip.options.defaultTemplate = '<div class="my-tooltip" role="tooltip"><div class="my-tooltip-arrow"></div><div class="my-tooltip-inner"></div></div>'
VTooltip.options.defaultArrowSelector = '.my-tooltip-arrow, .my-tooltip__arrow'
VTooltip.options.defaultInnerSelector = '.my-tooltip-inner, .my-tooltip__inner'

if (process.env.NODE_ENV === 'production') {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    }
    i[r].l = 1 * new Date()
    a = s.createElement(o)
    m = s.getElementsByTagName(o)[0]
    a.async = 1
    a.src = g
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga')
  // eslint-disable-next-line
  ga('create', 'UA-5355512-14', 'auto')
  // eslint-disable-next-line
  ga('send', 'pageview')
}

// eslint-disable-next-line no-undef
window.__COMMIT_HASH__ = __COMMIT_HASH__

let router = new VueRouter({
  mode: 'history',
  routes: [],
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
